<script lang="ts">
    import IconAdd from '../../../shared/Icons/IconAdd.svelte';
    import type { SvelteComponent } from 'svelte';
    import { _ } from 'svelte-i18n';

    import WhiteColor from '../../../shared/WhiteColor.svelte';
    import type { QuickCategories } from './QuickCategories';
    import { debug } from '../../../../stores/store';

    export let id: string = '';
    export let quantity: number = 0;
    export let adhoc: number = 0;
    export let iconComponent: SvelteComponent = IconAdd;
    export let color: string = '';
    export let backgroundColor: string = '#0000';
    export let borderColor: string = '#000000';
    export let quickCategories: QuickCategories;

    let colorDefault = color;
    let backgroundColorDefault = backgroundColor;
    let borderColorDefault = borderColor;

    // console.log('ScenarioOneQuickCategoriesOne', borderColorDefault);

    let active = false;
    let selected = false;

    $: {
        active = quickCategories.getCurrentId() === id || quickCategories.getCurrentId() === '';
        selected = quickCategories.getCurrentId() === id;
        color = colorDefault;
        backgroundColor = backgroundColorDefault;
        borderColor = selected && active ? borderColorDefault : 'transparent';
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
    class="container-quick-categories-one"
    class:selected
    class:not-active={!active}
    class:feature_1168_planning_page_colors={true}
    on:click
    style={'color:' +
        color +
        '; background-color:' +
        backgroundColor +
        '; box-shadow: 0px 0px 0px 1px ' +
        borderColor +
        ';'}
>
    <div class="title">{$_(id)}</div>
    <div class="container-lower">
        <div class="container-quantity">
            <div>
                {#if color === '#ffffff'}
                    <WhiteColor>
                        <svelte:component this={iconComponent} scale={0.7} {color} />
                    </WhiteColor>
                {:else}
                    <svelte:component this={iconComponent} scale={0.7} />
                {/if}
            </div>
            <div class="quantity">{quantity}</div>
        </div>
        {#if adhoc > 0 || $debug}
            <div class="container-adhoc" style="transform: translate(0, 3px);">
                <div
                    style="font-size: 17px; color: var(--planning-page-accent-color); font-weight: 600;"
                    class="dont-break"
                >
                    {#if $debug}
                        98765
                    {:else}
                        {adhoc}
                    {/if}
                </div>
                <div
                    style="font-size: 11px; color: var(--planning-page-accent-color); transform: translate(0, -2px);"
                    class="dont-break"
                >
                    ad-hoc
                </div>
            </div>
        {/if}
    </div>
</div>

<style>
    .container-quick-categories-one {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        border-radius: 7px; /* Janek mail */
        background-color: #f0f0f0;
        color: #343333;
        cursor: pointer;
        flex: 1 1 25%;
        border: 0 solid transparent;
        font-size: 14px;
        row-gap: 3px;
        min-height: 69px; /* Janek mail */
        margin: 2px;
        /*padding: 9px 9px;*/
        padding: 9px 9px 6px 9px;
    }
    .container-quick-categories-one.feature_1168_planning_page_colors {
        border: 0 solid transparent;
    }
    .selected {
        background-color: #e1eafc;
        color: #00245c;
        /*box-shadow: 0px 0px 0px 1px #7d8fac;*/
    }
    .not-active {
        opacity: 0.4;
    }
    .container-lower {
        display: flex;
        align-items: center;
        width: 100%;
        column-gap: 10px;
        justify-content: space-between;
        /*margin-bottom: 3px;*/
    }
    .quantity {
        font-size: 25px; /* Janek mail */
        font-weight: 600; /* Janek mail */
        line-height: 24px;
    }
    .title {
        font-size: 14px;
        display: flex;
        justify-content: flex-start;
        width: 100%;
        font-weight: 500;
        align-items: center;
        line-height: 13px;
        margin-top: 3px;
    }
    .container-quantity {
        display: flex;
        align-items: center;
        column-gap: 5px;
        flex-direction: row;
        margin-bottom: 3px;
    }
    .container-adhoc {
        display: flex;
        /*align-items: center;*/
        /*column-gap: 5px;*/
        flex-direction: column;
    }
    .container-adhoc > div {
        display: flex;
        justify-content: flex-end;
        font-size: 12px;
    }
</style>
